import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../../Services/UserProfileService';
import { IUserInfo } from '../../Models/UserProfileModel';
import { uploadService } from '../../../../shared/uploadService';
import { combineLatest, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { AuthService } from '../../../../../@core/auth/services';
import { FileVm } from '../../../../shared/Models/fileVm';
import { environment } from '../../../../../../environments/environment';
@Component({
  selector: "get-user-profile",
  templateUrl: "./get-user-profile.component.html",
  styleUrls: ["./get-user-profile.component.scss"],
})
export class GetUserProfileComponent implements OnInit {
  userProfile: IUserInfo = {} as IUserInfo;
  formData = new FormData();
  uploadThumbnail = false;
  confirmPassword: string = "";
  private imagePath: string;
  private validPhoto: boolean = false;
  private imgURL: any;
  private file: FileVm[] = [];
  private newPhotoUploaded = false;
  isLoading: boolean = false;

  constructor(
    private userService: UserService,
    private uploadservice: uploadService,
    private toast: NbToastrService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.userService.getUser().subscribe({
      next: (res) => {
        if(res && res !== null && res !== undefined) {
        this.userProfile = res;
        if (!this.userProfile.profilePictureFilePath) {
          this.uploadThumbnail = true;
          this.validPhoto = false;
        }
           this.imagePath = this.userProfile.profilePictureFilePath
          .substring(0,this.userProfile.profilePictureFilePath.lastIndexOf('/'));
                console.log( "imagePath ="+"   "+ this.imagePath.substring(0,13));
        }
        this.formData.append("file", this.userProfile.profilePictureFilePath);
      },
      error: (err) => {
        this.toast.danger(' 1 خطأ في تحميل بيانات المستخدم', 'خطأ', { status: 'danger', duration: 3000 });
      }
    });
  }

  updateProfile() {
    this.isLoading = true;

    const attachment$ = this.validPhoto
      ? this.uploadservice.uploadImage(this.formData)
      : of(null);

    combineLatest([attachment$])
      .pipe(
        switchMap(([img]) => {
          if (img && img.fileName) {
            this.userProfile.profilePictureFilePath =
              img && img.path ? img.path : "";
            this.userProfile.profilePictureFileName =
              img && img.fileName ? img.fileName : "";
          }
          if (
            this.userProfile.password &&
            this.userProfile.password.length > 0
          ) {
            if (!this.checkPasswordMatch()) {
              this.toast.danger("كلمة المرور غير متطابقة", "خطأ", {
                status: "danger",
                duration: 3000,
              });
              return;
            }
          }

          if(!this.validPhoto)
          {
            this.userProfile.isDeletedPhoto = true;
          }
             console.log( "imagePath ="+ this.imagePath.substring(0,13)+"   "+ "fileName ="+ this.userProfile.profilePictureFileName);
           this.userService.updateImage(this.imagePath+'/'+this.userProfile.profilePictureFileName);
           return  this.userService.put(this.userProfile.id, this.userProfile)
        })
      )
      .subscribe({
        next: (res) => {
           this.toast.show('تم تعديل بيانات الادمن بنجاح', '', { status: 'success', duration: 3000 });
        },
        error: (err) => {
          this.isLoading = false;
          this.toast.danger("خطأ في تعديل بيانات الادمن ", "خطأ", {
            status: "success",
            duration: 3000,
          });
        },
      });
  }

  removePhoot() {
    this.uploadThumbnail = true;
     this.validPhoto = false;
     this.userProfile.profilePictureFilePath = '';
     this.userProfile.profilePictureFileName = '';
  }

  checkPasswordMatch(): boolean {
    if (this.userProfile.password !== this.confirmPassword) {
      return false;
    }
    return true;
  }

  getFormData(event) {
    this.formData = event;
    if (event) this.validPhoto = true;
  }
}
